import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

export class ZoomInIcon extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon fill="#F0F0F0" {...this.props}>
                <path
                    d={`
                          M16.2,13.5l5.5,5.5
                          c0.4,0.4,0.4,1,0,1.4l-1.3,1.3
                          c-0.4,0.4-1,0.4-1.4,0l-5.5-5.5
                          c-1.1,0.7-2.5,1.1-3.9,1.1C5.4,17.2,2,13.8,2,9.6C2,
                          5.4,5.4,2,9.6,2s7.6,3.4,7.6,7.6C17.2,11,16.8,12.4,16.2,13.5z M10.6,8.7V5.8
                          c0-0.5-0.4-1-1-1s-1,0.4-1,1v2.9H5.8
                          c-0.5,0-1,0.4-1,1c0,0.5,0.4,1,1,1h2.9v2.9c0,
                          0.5,0.4,1,1,1s1-0.4,1-1v-2.9h2.9c0.5,0,1-0.4,1-1
                          c0-0.5-0.4-1-1-1H10.6z
                      `}
                />
            </SvgIcon>
        );
    }
}
